module.exports = __webpack_public_path__ + "press_page_design_innovative_graphicdesign_digitalfactory_griddesign.jpg?1524d635f443ef6be5fe412ea9c0c1ab";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/press_page_design_innovative_graphicdesign_digitalfactory_griddesign.jpg
// module id = 57
// module chunks = 0